import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateStepForLead as UpdateStepForLeadMutation,
    UpdateStepForLeadVariables,
    StepUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_STEP_FOR_LEAD from '../mutations/update-step-for-lead.graphql';

export const useUpdateStepForLead = (): {
    updateStepForLead: (arg1: StepUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateStepForLead, {loading, error}] = useMutation<
        UpdateStepForLeadMutation,
        UpdateStepForLeadVariables
    >(UPDATE_STEP_FOR_LEAD);

    return {
        updateStepForLead: (input: StepUpdateInput) => updateStepForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
